module.exports = __webpack_public_path__ + "static/media/48pic.103cc469.jpg";